/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

import { FormikProps } from 'formik';

import { AllowanceEnums, AllowancesNames } from '@pharmaplan/common';

const { meal, travel, accommodation, emergency, others } = AllowanceEnums;
const {
  mealAllowance,
  accommodationAllowance,
  travelAllowanceAmount,
  travelAllowanceRatePerKm,
  emergencyFees,
  travelAllowanceType,
  accommodationAllowanceType,
} = AllowancesNames;

const useSyncWorkshiftValues = (formik: FormikProps<any>, allowRun = true) => {
  const isMounted = useRef(false);

  const { values } = formik ?? {};
  const propertiesToEmpty = {
    [meal]: [{ name: mealAllowance, resetValue: null }],
    [travel]: [
      { name: travelAllowanceAmount, resetValue: null },
      { name: travelAllowanceRatePerKm, resetValue: null },
      { name: travelAllowanceType, resetValue: [] },
    ],
    [accommodation]: [
      { name: accommodationAllowance, resetValue: null },
      { name: accommodationAllowanceType, resetValue: null },
    ],
    [emergency]: [{ name: emergencyFees, resetValue: null }],
    [others]: [{ name: emergencyFees, resetValue: null }],
  };

  const emptyIfNotPresent = (val: AllowanceEnums) => {
    if (!values?.[val]) {
      propertiesToEmpty[val].forEach(({ name, resetValue }) => {
        formik.setFieldValue(name, resetValue);
      });
    }
  };

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    if (allowRun) {
      // ONLY APPLY ON UPDATE
      emptyIfNotPresent(meal);
      emptyIfNotPresent(travel);
      emptyIfNotPresent(accommodation);
      emptyIfNotPresent(emergency);
    }
  }, [values[meal], values[travel], values[accommodation], values[emergency]]);
};

export default useSyncWorkshiftValues;
